/* __next_internal_client_entry_do_not_use__ FadeIn,FadeInScale,StaggerContainer,StaggerItem auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import React from 'react';
export function FadeIn(param) {
    let { children, className, delay = 0 } = param;
    return /*#__PURE__*/ _jsx(motion.div, {
        initial: {
            opacity: 0,
            y: 20
        },
        whileInView: {
            opacity: 1,
            y: 0
        },
        viewport: {
            once: true,
            margin: '-50px'
        },
        transition: {
            duration: 0.5,
            delay,
            ease: 'easeOut'
        },
        className: className,
        children: children
    });
}
export function FadeInScale(param) {
    let { children, className, delay = 0 } = param;
    return /*#__PURE__*/ _jsx(motion.div, {
        initial: {
            opacity: 0,
            scale: 0.95
        },
        whileInView: {
            opacity: 1,
            scale: 1
        },
        viewport: {
            once: true,
            margin: '-50px'
        },
        transition: {
            duration: 0.5,
            delay,
            ease: 'easeOut'
        },
        className: className,
        children: children
    });
}
export function StaggerContainer(param) {
    let { children, className } = param;
    return /*#__PURE__*/ _jsx(motion.div, {
        initial: "hidden",
        whileInView: "visible",
        viewport: {
            once: true,
            margin: '-50px'
        },
        variants: {
            visible: {
                transition: {
                    staggerChildren: 0.1
                }
            }
        },
        className: className,
        children: children
    });
}
export function StaggerItem(param) {
    let { children, className } = param;
    return /*#__PURE__*/ _jsx(motion.div, {
        variants: {
            hidden: {
                opacity: 0,
                y: 20
            },
            visible: {
                opacity: 1,
                y: 0,
                transition: {
                    duration: 0.5,
                    ease: 'easeOut'
                }
            }
        },
        className: className,
        children: children
    });
}
